module.exports = __webpack_public_path__ + "img/organization_settings.8ee6df0d.svg";